import axios from "axios";
import { JWT } from "../shared";
export const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const axioClient = (header) => {
  return axios.create({
    baseURL: `${API_BASE_URL}`,
    headers: header,
  });
};

const getHeader = (isAuth = false, isImage = false) => {
  const access_token = localStorage.getItem("authToken");
  if (isAuth && access_token) {
    if (isImage) {
      return {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${access_token}`,
      };
    }
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    };
  } else {
    return { "Content-Type": "application/json" };
  }
};

// const handleResponse = (response) => {
//   if (response.status === 200) {
//     response = response?.data;
//     if (
//       response?.success === true
//     ) {
//       return {
//         success: true,
//         data: response.data,
//         message: response.message,
//         // recordsTotal: response.Result.recordsTotal,
//       };
//     } else {
//       return { isSuccess: false, message: response.Errors[0]?.message };
//     }
//   } else {
//     return Promise.reject(new Error("Internal server error"));
//   }
// };

const handleResponse = (response) => {
  if (response.status === 200) {
    response = response?.data;
    return {
      success: response?.success || false,
      data: response?.data || null,
      message: response?.message || (response?.Errors && response.Errors[0]?.message) || "Unknown error"
    };
  } else {
    return Promise.reject(new Error("Internal server error"));
  }
};



const handleError = (error) => {
  console.log("handleError :: ", error);
  if (error.response) {
    // Handle 400 or 401
    if (
      error.response.status === 400 ||
      error.response.status === 404 ||
      error.response.status === 402
    ) {
      console.log("Bad Request: ", error?.response?.data);
      console.log("Message : ", error?.response?.data?.Errors[0]?.Message);
      return Promise.reject(
        new Error(error?.response?.data?.Errors[0]?.Message)
      );
    } else if (error.response.status === 401) {
      console.log("Unauthorized: ", error.response.data);
      return Promise.reject(
        new Error(error?.response?.data?.Errors[0]?.Message)
      );
    } else {
      console.log("Other error: ", error?.response?.status);
      return Promise.reject(new Error("An error occurred"));
    }
  } else if (error.request) {
    console.log("No response received");
    return Promise.reject(new Error("No response received"));
  } else {
    console.log("Error", error.message);
    return Promise.reject(new Error(error?.message));
  }
};

export default {
  axioClient,
  getHeader,
  handleResponse,
  handleError,
};
